import React from "react";

/** Shared presentation for the MFA screens (setup, verify, disable, backup codes). */

export const otpInputClass =
  "zs-input !h-12 w-full max-w-[48px] !px-0 text-center text-lg font-semibold tabular-nums font-display";

export const backupCodeInputClass = "zs-input !h-12 text-center font-mono tracking-widest uppercase";

export const MfaIconBadge = ({
  children,
  tone = "primary",
  size = "md",
}: {
  children: React.ReactNode;
  tone?: "primary" | "success" | "danger";
  size?: "md" | "lg";
}) => {
  const toneClass =
    tone === "success"
      ? "bg-success-soft text-success"
      : tone === "danger"
      ? "bg-danger-soft text-danger"
      : "bg-primary-soft text-primary-text";
  const sizeClass = size === "lg" ? "w-14 h-14 text-2xl rounded-full" : "w-10 h-10 text-xl rounded";
  return <span className={`inline-flex items-center justify-center shrink-0 ${toneClass} ${sizeClass}`}>{children}</span>;
};

export const BackupCodeGrid = ({ codes }: { codes: string[] }) => (
  <div className="grid grid-cols-2 gap-2 p-3 border rounded-lg bg-surface-2 border-line">
    {codes.map((code, i) => (
      <div
        key={i}
        className="px-3 py-2 font-mono text-sm tracking-widest text-center border rounded bg-surface border-line text-ink"
      >
        {code}
      </div>
    ))}
  </div>
);

export const mfaActionButtonClass = "zs-btn zs-btn-secondary zs-btn-sm w-full";
